// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"271a79fc","414":"4724516c","969":"8bfb434b"}[chunkId] + ".chunk.js";
};